import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_ProsemirrorViewerTable = _resolveComponent("ProsemirrorViewerTable");
    const _component_EditorNodeWrapper = _resolveComponent("EditorNodeWrapper");
    return (_openBlock(), _createBlock(_component_EditorNodeWrapper, {
        class: _normalizeClass(['node-container', 'table-container', _ctx.rowTypeClass, _ctx.blockWidthClass]),
        onObserveNodeVisibility: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('observe-node-visibility', Object.assign(Object.assign({}, $event), { nodeId: _ctx.node.id }))))
    }, {
        default: _withCtx(() => [
            _createVNode(_component_ProsemirrorViewerTable, {
                content: _ctx.jsonContent,
                "border-color": _ctx.borderColor,
                "alternate-row-color": _ctx.alternateRowColor,
                "header-row-background-color": _ctx.headerRowBackgroundColor,
                "merge-values": _ctx.mergeValues,
                fields: _ctx.fields,
                "is-pdf-viewer": _ctx.isPdfViewer
            }, null, 8, ["content", "border-color", "alternate-row-color", "header-row-background-color", "merge-values", "fields", "is-pdf-viewer"])
        ]),
        _: 1
    }, 8, ["class"]));
}
